
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M5.5 11V9.5C5.5 5.91015 8.41015 3 12 3C15.5899 3 18.5 5.91015 18.5 9.5V11M5.5 11C6.32843 11 7 11.6716 7 12.5V15.5C7 16.3284 6.32843 17 5.5 17C4.67157 17 4 16.3284 4 15.5V12.5C4 11.6716 4.67157 11 5.5 11ZM18.5 11C19.3284 11 20 11.6716 20 12.5V15.5C20 16.3284 19.3284 17 18.5 17M18.5 11C17.6716 11 17 11.6716 17 12.5V15.5C17 16.3284 17.6716 17 18.5 17M18.5 17C18.5 19.2091 16.7091 21 14.5 21H14M14 21C14 21.5523 13.5523 22 13 22C12.4477 22 12 21.5523 12 21C12 20.4477 12.4477 20 13 20C13.5523 20 14 20.4477 14 21Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiCustomerService",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
